import appSettings from 'app/appSettings';
import { get } from 'core/communication';
import { AuthResponse } from './types';

const BASE_URL = appSettings.apis.authService.url;

// eslint-disable-next-line import/prefer-default-export
export async function getUserInfo(accessToken: string): Promise<AuthResponse> {
  const url = `${BASE_URL}/users/userinfo/token?version=${appSettings.version}`;
  const result = await get<AuthResponse>(url, accessToken);
  return result;
}
